<template>
	
	<div>
		
		<section class="breadcrumbs">
		  <div class="container">
		    <ol>
		      <li><router-link to="/"><a href="">首页</a></router-link></li>
		      <li>关于我们</li>
		    </ol>
		    <h2>关于我们</h2>
		  </div>
		</section>
		
		<!-- ======= 关于我们 ======= -->
		<section id="contact" class="contact">
		  <div class="container" data-aos="fade-up">
			<article class="is-dark art ql-editor" v-html="$utils.fixImgInRichText(about.top)"></article>
			<br/>
			<article class="is-light art ql-editor" v-html="$utils.fixImgInRichText(about.bottom)"></article>
		  </div>
		</section>
		
	</div>
	
</template>

<script>
	import axios from 'axios'
	export default{
		data() {
			return {
				aboutAll: [],
				about: {}
			}
		},
		mounted() {
			this.getDetail();
		},
		methods:{
			async getDetail(id){
				try{
					const resp = await axios.get('/api/system/about/list');
					this.aboutAll = [];
					this.aboutAll = JSON.parse(JSON.stringify(resp.data.rows));
					this.about = this.aboutAll[0];
				}catch(e){
					console.log(e);
				}
			},
		}
	}
</script>

<style scoped>
	.art img{
		max-width: 856px;
	}
</style>